import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { zonesTypes } from "../constantes/actionTypes"

export const zonesActions = {
    getZones: () => (
        createMiddlewareAction({
            successType: zonesTypes.GET_ALL_ZONES_SUCCESS,
            failureType: zonesTypes.GET_ALL_ZONES_FAILURE,
            method: "GET",
            endpoint: endpoints.ALL_ZONES
        })
    ),
}